<script lang="ts">
    import {imask} from '@imask/svelte'
    import axios from 'axios'
    import * as utils from '../common/get-query-string'
    import {onMount} from 'svelte'

    /*
    maintenanceEnabled: (document.querySelector('input[name="me"]'))?.value,
    maintenanceType: (document.querySelector('input[name="mt"]'))?.value,
    maintenanceMessage: (document.querySelector('input[name="mm"]'))?.value,
    maintenanceLogin: (document.querySelector('input[name="ml"]'))?.value
     */
    export let maintenanceEnabled
    export let maintenanceLogin
    export let maintenanceMessage
    export let maintenanceType

    export let end: boolean = false
    export let sessionId
    export let app: string = ''
    let selectedApp: string = app ? app : 'api'
    let username: string = ''
    let password: string = ''
    let usernameInput: HTMLInputElement
    let passwordInput: HTMLInputElement
    let tfaCode: string = ''

    let processing: boolean = false
    let tfaForm: boolean = false

    export let error: string = ''
    export let warning: string = ''
    let success: string = ''
    let ors: number | null = null;

    const shortCodeMask = {
        mask: '000-000',
        lazy: false
    }

    window.setApp = (appc) => {
        selectedApp = appc
    }

    let doLoginAndReport = async () => {
        if (!window.bureau_callback__submit)
            window.bureau_callback__submit = (cb) => {
                cb()
            }
        window.bureau_callback__submit(() => {
            doLogin()
        })
    }

    const doLogin = async () => {
        if (maintenanceEnabled === '1' && maintenanceLogin !== '1') return;
        
        username = usernameInput?.value || username
        password = passwordInput?.value || password

        error = ''
        success = ''

        processing = true

        let response = (tfaForm
                ? (await axios.post(`/Account/Login/Confirm`, {
                    userName: username,
                    password: password,
                    confirmationCode: tfaCode,
                    originalResponseCode: ors,
                    source: selectedApp,
                    returnUrl: (utils.hasUrlParameter('ReturnUrl') ? utils.getUrlParameter('ReturnUrl') : '/'),
                }))
                : (await axios.post(`/Account/Login/Process`, {
                    userName: username,
                    sessionId: sessionId,
                    password: password,
                    rememberMe: false,
                    source: selectedApp,
                    returnUrl: (utils.hasUrlParameter('ReturnUrl') ? utils.getUrlParameter('ReturnUrl') : '/'),
                }))
        )

        if (response.data.responseCode === 99 || response.data.responseCode === 98) {
            success = 'You have logged in successfully. Please wait while we load your account.'
            window.location.href = response.data.link
        } else if (response.data.responseCode === 9 || response.data.responseCode === 4) {
            // Already on the code form, so this is a wrong code rather than a new challenge
            if (tfaForm) error = response.data.message
            else success = response.data.message
            processing = false
            tfaForm = true
            ors = response.data.responseCode
        } else {
            // A failed confirmation (expired, too many attempts) needs a fresh sign in and a new code
            if (tfaForm) {
                tfaForm = false
                tfaCode = ''
                ors = null
            }
            error = response.data.message
            processing = false
        }
    }

    onMount(() => {
        console.dir({maintenanceEnabled, maintenanceType, maintenanceMessage, maintenanceLogin})
    })
</script>

<form on:submit|preventDefault|stopPropagation={doLoginAndReport}>
    <div class="container-fluid container-lg min-vh-100 d-flex justify-content-center align-items-center">
        <div class="row m-md-5 no-gutters shadow-lg px-0 responsive-fix">
            <div class="col-lg-12 mt-5 service-provider-logo mx-auto">
            </div>
            <div class="col-lg-12 p-md-5">
                <div class="form-style">
                    {#if maintenanceEnabled === '1' && maintenanceMessage}
                        <div class="form-group row mb-3 mx-1">
                            <div class="alert alert-{maintenanceType}">
                                {@html maintenanceMessage}
                            </div>
                        </div>
                    {/if}
                    {#if success}
                        <div class="form-group row mb-3 mx-1">
                            <div class="alert alert-success">
                                {@html success}
                            </div>
                        </div>
                    {/if}
                    {#if warning}
                        <div class="form-group row mb-3 mx-1">
                            <div class="alert alert-warning">
                                {@html warning}
                            </div>
                        </div>
                    {/if}
                    {#if error}
                        <div class="form-group row mb-3 mx-1">
                            <div class="alert alert-danger">
                                {@html error}
                            </div>
                        </div>
                    {/if}
                    {#if (maintenanceEnabled === '0' || maintenanceLogin !== '0')}
                        {#if !tfaForm}
                            {#if !app}
                                <div class="form-group row mb-3">
                                    <div class="col-12">
                                        <select class="form-select" id="selApp" bind:value={selectedApp}>
                                            <option value="api">EnformionGO API</option>
                                            <option value="lead">EnformionGO LeadBuilder</option>
                                            <option value="lead">EnformionGO Batch</option>
                                            <option value="search">EnformionGO Search</option>
                                            <option value="admin">Admin/Billing</option>
                                        </select>
                                    </div>
                                </div>
                            {/if}
                            <div class="form-group row mb-3">
                                <div class="col-12">
                                    <input bind:this={usernameInput} bind:value={username} autocomplete="username" class="form-control" 
                                           placeholder="Username" disabled={processing} id="txtUsername"
                                           data-testid="input-username"
                                           type="text"/>
                                </div>
                            </div>
                            <div class="form-group row mb-3">
                                <div class="col-12">
                                    <input bind:this={passwordInput} bind:value={password} autocomplete="current-password" class="form-control"
                                           placeholder="Password" disabled={processing} id="txtPassword"
                                           data-testid="input-password"
                                           type="password"/>
                                </div>
                            </div>
                        {:else}
                            <div class="form-group row mb-3">
                                <label class="form-label col-3" for="txtCode">Confirmation Code</label>
                                <div class="col-9">
                                    <input
                                            use:imask={shortCodeMask}
                                            on:complete={({detail}) => { tfaCode = detail.value }}
                                            class="form-control"
                                            disabled={processing}
                                            id="txtCode"
                                            type="text"/>
                                </div>
                            </div>
                        {/if}
                    {/if}
                    <div class="row">
                        {#if !tfaForm}
                            <div class="col">
                                <a href="/Account/ResetPassword">Forgot your password?</a>
                            </div>
                        {/if}
                        <div class="col text-end">
                            <button class="btn btn-primary" class:disabled={processing}
                                    data-testid="btn-login"
                                    type="submit">{@html (processing ? '<i class="fa-solid fa-spinner fa-spin"></i> Please wait...' : 'Login')}</button>
                        </div>
                    </div>
                    {#if end}
                        <div class="row">
                            <div class="col">
                                Don't have an account? <a href="//accounts.enformion.com/Join">Sign Up</a>
                            </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</form>
<style>
    .service-provider-logo {
        margin-top: 1rem;
        margin-left: 1rem;
        display: block;
        width: 220px;
        height: 53px;
        transform: var(--logo-transform);
        background-image: var(--logo-path);
        background-size: contain;
        background-repeat: no-repeat;
    }
	
	@media (max-width: 768px) {
        .service-provider-logo {
		    margin-bottom: 2rem;
            width: clamp(130px, 40vw, 220px);
            height: 39px;
            margin-left: auto;
            margin-right: auto;
        }
    }

    @media (max-width: 768px) {
        .responsive-fix {
            display: block;
            margin: 0;
            padding: 0;
            width: 100vw !important;
            height: 100vh !important;
        }
    }
</style>
